import * as angular from "angular";

angular
  .module('bringoz.admin.groups')
  .config(groupsConfig);

/* @ngInject */
function groupsConfig($stateProvider) {

  $stateProvider

    // Groups
    .state('groups', {
      parent: 'bringoz.site',
      url: '/groups',
      template: '<groups-view></groups-view>',
      controller: function ($scope, triBreadcrumbsService, site) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Groups"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })

}
